var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMonitor = function SvgMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6c-.3 0-.5.2-.5.5v4c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-4c0-.3-.2-.5-.5-.5h-11z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2 2C.9 2 0 2.9 0 4v9c0 1.1.9 2 2 2h7v2H6c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1h-3v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H2zm15 11c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1h14z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMonitor;